module.exports = __webpack_public_path__ + "img/login-logo.52dcfb3c.png";